/* Mobile menu burger toggle */
(function () {
  const nav = document.querySelector(".gh-navigation");
  const burger = nav?.querySelector(".gh-burger");
  if (!burger) return;

  burger.addEventListener("click", () => {
    const isOpen = nav.classList.toggle("is-open");
    document.documentElement.style.overflowY = isOpen ? "hidden" : "";
  });
})();

/* Responsive video in post content */
(function () {
  const sources = [
    '.post-content iframe[src*="youtube.com"]',
    '.post-content iframe[src*="youtube-nocookie.com"]',
    '.post-content iframe[src*="player.vimeo.com"]',
    '.post-content iframe[src*="kickstarter.com"][src*="video.html"]',
    ".post-content object",
    ".post-content embed",
  ];
  reframe(document.querySelectorAll(sources.join(",")));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
  dropdown();
})();

/* Infinite scroll pagination */
(function () {
  if (
    !document.body.classList.contains("home-template") &&
    !document.body.classList.contains("post-template")
  ) {
    pagination();
  }
})();

////Tag page filter
document.addEventListener("DOMContentLoaded", async () => {
  if (!document.body.classList.contains("tag-template")) return;

  const config = window.TAG_CONFIG;
  const tagIndex = window.location.pathname.indexOf("/tag/");
  const basePath = tagIndex > 0 ? window.location.pathname.slice(0, tagIndex) : "";
  const POSTS_PER_PAGE = 8;
  let currentFilter = "";
  let currentPage = 1;
  let isLoading = false;
  let totalPages = 1;
  let filterTagNames = {};

  const feed = document.getElementById("post-feed");
  const ghostPagination = document.getElementById("ghost-pagination");
  const paginationContainer = document.getElementById("pagination-numbers");
  const filterList = document.querySelector(".all-tags-list");
  const filterName = document.querySelector("#current-filter");

  const ARROW_L = `<svg aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.52341 9.16689L10.9934 4.69689L9.81508 3.51855L3.33342 10.0002L9.81508 16.4819L10.9934 15.3036L6.52341 10.8336H16.6667V9.16689H6.52341Z" fill="#161B25"/></svg>`;
  const ARROW_R = `<svg aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.4766 9.16689L9.00658 4.69689L10.1849 3.51855L16.6666 10.0002L10.1849 16.4819L9.00658 15.3036L13.4766 10.8336H3.33325V9.16689H13.4766Z" fill="#161B25"/></svg>`;

  // SSR fallback: filter posts already rendered by Ghost, no API needed
  function initDomFallback() {
    const wrappers = [...feed.querySelectorAll(".post-card-wrapper")];
    const tagMap = {};

    wrappers.forEach((w) => {
      w.querySelectorAll(".js-post-tag-meta").forEach((meta) => {
        const slug = meta.dataset.slug;
        const rawName = meta.dataset.name || slug;
        const displayName = rawName.startsWith("#")
          ? rawName.slice(1)
          : rawName;
        if (!tagMap[slug]) tagMap[slug] = { name: displayName, count: 0 };
        tagMap[slug].count++;
      });
    });

    document.querySelector("[data-count='all']").textContent = wrappers.length;

    Object.entries(tagMap).forEach(([slug, { name, count }]) => {
      const li = document.createElement("li");
      li.className = "tag-filter-item";
      li.innerHTML = `<button class="filter-btn tag-link" data-filter="${slug}">${name} <span class="posts-count">${count}</span></button>`;
      filterList.appendChild(li);
    });

    filterList.classList.add("is-visible");

    filterList.querySelectorAll(".filter-btn").forEach((btn) => {
      btn.onclick = () => {
        const slug = btn.getAttribute("data-filter");
        const isAll = slug === "all";
        wrappers.forEach((w) => {
          const tags = (w.dataset.tags || "")
            .trim()
            .split(/\s+/)
            .filter(Boolean);
          w.hidden = !isAll && !tags.includes(slug);
        });
        filterList
          .querySelectorAll(".filter-btn")
          .forEach((b) => b.classList.toggle("active", b === btn));
        filterName.textContent = isAll ? "Всі" : tagMap[slug]?.name || slug;
      };
    });
  }

  // Lightweight fetch: all post IDs + tags for counting filter buttons
  async function fetchCounts() {
    const url = new URL(`${basePath}/ghost/api/content/posts/`, window.location.origin);
    url.searchParams.set("key", config.apiKey);
    url.searchParams.set("filter", `tag:${config.tagSlug}+visibility:public`);
    url.searchParams.set("include", "tags");
    url.searchParams.set("fields", "id");
    url.searchParams.set("limit", "all");
    const res = await fetch(url);
    const data = await res.json();
    return data.posts || [];
  }

  // Paginated fetch with optional server-side internal tag filter
  async function fetchPage(page, internalTagSlug) {
    const url = new URL(`${basePath}/ghost/api/content/posts/`, window.location.origin);
    url.searchParams.set("key", config.apiKey);
    let filter = `tag:${config.tagSlug}+visibility:public`;
    if (internalTagSlug) filter += `+tag:${internalTagSlug}`;
    url.searchParams.set("filter", filter);
    url.searchParams.set("include", "tags,authors");
    url.searchParams.set("fields","title,url,slug,feature_image,published_at,primary_tag,primary_author,html,reading_time");
    url.searchParams.set("limit", String(POSTS_PER_PAGE));
    url.searchParams.set("page", String(page));
    const res = await fetch(url);
    return res.json();
  }

  function renderCard(post) {
    const img = post.feature_image
      ? `<figure class="post-card-img">
          <img src="${post.feature_image}" alt="${post.feature_image_alt || post.title}"
              loading="lazy" width="310" height="200" decoding="async">
         </figure>`
      : "";
    const tag = post.primary_tag
      ? `<a class="post-tag" href="${post.primary_tag.url}">${post.primary_tag.name}</a>`
      : "";
    const author = post.primary_author
      ? `<a href="${post.primary_author.url}" class="post-card-author">${post.primary_author.name}</a>`
      : "";
    const date = new Date(post.published_at).toLocaleDateString("uk-UA", {
      day: "numeric", month: "long", year: "numeric"
    });
    const readTime = post.reading_time
      ? `<span class="post-card-time">&nbsp;${post.reading_time} хв. на читання</span>`
      : "";
    return `
      <div class="post-card-wrapper">
          <article class="post-card">
              <a href="${post.url}" aria-label="${post.title}">${img}</a>
              <div class="post-card-info">
                  ${tag}
                  <h3 class="post-card-title">
                      <a href="${post.url}" title="${post.title}">${post.title}</a>
                  </h3>
                  <div class="post-card-meta">
                      ${author}
                      <time class="post-card-date">${date.slice(0, -2)}&nbsp;&nbsp;|</time>
                      ${readTime}
                  </div>
              </div>
          </article>
      </div>`;
  }

  function buildFilters(countPosts) {
    const tagMap = {};
    countPosts.forEach(post => {
      (post.tags || [])
        .filter(t => t.visibility === "internal")
        .forEach(t => {
          if (!tagMap[t.slug]) {
            const displayName = t.name.startsWith("#")
              ? t.name.slice(1)
              : t.name;
            tagMap[t.slug] = { name: displayName, count: 0 };
            filterTagNames[t.slug] = displayName;
          }
          tagMap[t.slug].count++;
        });
    });
    document.querySelector('[data-count="all"]').textContent = countPosts.length;
    Object.entries(tagMap).forEach(([slug, { name, count }]) => {
      const li = document.createElement("li");
      li.className = "tag-filter-item";
      li.innerHTML = `<button class="filter-btn tag-link" data-filter="${slug}">${name} <span class="posts-count">${count}</span></button>`;
      filterList.appendChild(li);
    });
    filterList.classList.add("is-visible");
    setupFilters();
  }

  function renderPagination(pages, page) {
    paginationContainer.innerHTML = "";
    if (pages <= 1) return;

    const createBtn = (content, targetPage, isCurrent = false, isDisabled = false, className = "") => {
      const btn = document.createElement("button");
      btn.innerHTML = content;
      if (className) btn.classList.add(className);
      if (isCurrent) btn.classList.add("current");
      if (isDisabled) btn.disabled = true;
      if (!isDisabled && !isCurrent) btn.onclick = () => goToPage(targetPage);
      return btn;
    };

    const createDots = () => {
      const span = document.createElement("span");
      span.className = "extra";
      span.textContent = "...";
      return span;
    };

    paginationContainer.appendChild(
      createBtn(`${ARROW_L}<span>Попередня</span>`, page - 1, false, page === 1, "prev-next")
    );
    const numbersContainer = document.createElement("div");
    numbersContainer.classList.add("pagination-numbers");
    for (let i = 1; i <= pages; i++) {
      if (i === 1 || i === pages || (i >= page - 1 && i <= page + 1)) {
        numbersContainer.appendChild(createBtn(i, i, i === page));
      } else if (i === page - 2 || i === page + 2) {
        numbersContainer.appendChild(createDots());
      }
    }
    paginationContainer.appendChild(numbersContainer);
    paginationContainer.appendChild(
      createBtn(`<span>Наступна</span>${ARROW_R}`, page + 1, false, page === pages, "prev-next")
    );
  }

  function readUrlState() {
    const pathParts = window.location.pathname.split("/");
    const pageIndex = pathParts.indexOf("page");
    const page = pageIndex !== -1 && pathParts[pageIndex + 1]
      ? parseInt(pathParts[pageIndex + 1], 10)
      : 1;
    const filter = new URLSearchParams(window.location.search).get("filter") || "";
    return { page, filter };
  }

  function syncUrlState(page, filter, replace = false) {
    const base = window.location.pathname
      .replace(/\/page\/\d+\/?$/, "")
      .replace(/\/$/, "") + "/";
    let path = page > 1 ? `${base}page/${page}/` : base;
    if (filter) path += `?filter=${filter}`;
    const method = replace ? "replaceState" : "pushState";
    window.history[method]({ page, filter }, "", path);
  }

  function setActiveBtn(filter) {
    filterList.querySelectorAll(".filter-btn").forEach(btn => {
      const slug = btn.getAttribute("data-filter");
      btn.classList.toggle("active", filter ? slug === filter : slug === "all");
    });
  }

  async function loadAndRender(page, filter, replace = false) {
    if (isLoading) return;
    isLoading = true;
    feed.style.opacity = "0.5";
    paginationContainer.innerHTML = "";

    try {
      const data = await fetchPage(page, filter);
      const posts = data.posts || [];
      const pagination = data.meta?.pagination || {};

      currentPage = page;
      currentFilter = filter;
      totalPages = pagination.pages || 1;

      feed.innerHTML = posts.map(renderCard).join("");
      filterName.textContent = filter ? (filterTagNames[filter] || filter) : "Всі";
      renderPagination(totalPages, currentPage);
      setActiveBtn(filter);
      syncUrlState(page, filter, replace);
    } finally {
      feed.style.opacity = "";
      isLoading = false;
    }
  }

  function goToPage(page) {
    loadAndRender(page, currentFilter);
    window.scrollTo({ top: feed.offsetTop - 100, behavior: "smooth" });
  }

  function setupFilters() {
    filterList.querySelectorAll(".filter-btn").forEach(btn => {
      btn.onclick = () => {
        const slug = btn.getAttribute("data-filter");
        loadAndRender(1, slug === "all" ? "" : slug);
      };
    });
  }

  window.addEventListener("popstate", e => {
    const { page = 1, filter = "" } = e.state || readUrlState();
    loadAndRender(page, filter, true);
  });

  // No API key → stay with SSR DOM fallback
  if (!config?.apiKey || !config?.tagSlug) {
    initDomFallback();
    return;
  }

  ghostPagination.style.display = "none";

  const { page: initPage, filter: initFilter } = readUrlState();
  const isInitialView = initPage === 1 && !initFilter;

  try {
    if (isInitialView) {
      // SSR вже показав правильні пости — не замінюємо їх
      // Тільки fetchCounts для фільтрів і підрахунку сторінок
      const countPosts = await fetchCounts();
      buildFilters(countPosts);
      currentPage = 1;
      currentFilter = "";
      totalPages = Math.ceil(countPosts.length / POSTS_PER_PAGE);
      filterName.textContent = "Всі";
      renderPagination(totalPages, 1);
      setActiveBtn("");
      syncUrlState(1, "", true);
    } else {
      // Закладка або пряме посилання на сторінку 2+ чи з фільтром
      const [countPosts, initData] = await Promise.all([
        fetchCounts(),
        fetchPage(initPage, initFilter),
      ]);
      buildFilters(countPosts);

      currentPage = initPage;
      currentFilter = initFilter;
      totalPages = initData.meta?.pagination?.pages || 1;
      feed.innerHTML = (initData.posts || []).map(renderCard).join("");
      filterName.textContent = initFilter ? (filterTagNames[initFilter] || initFilter) : "Всі";
      renderPagination(totalPages, currentPage);
      setActiveBtn(initFilter);
      syncUrlState(initPage, initFilter, true);
    }
  } catch (err) {
    ghostPagination.style.display = "";
    initDomFallback();
  }
});

// FAQ

document.addEventListener("DOMContentLoaded", function () {
  if (!document.body.classList.contains("post-template")) return;
  const faq = document.querySelector(".faq");
  if (!faq) return;

  faq.addEventListener("click", function (e) {
    const question = e.target.closest(".faq-question");
    question?.parentElement.classList.toggle("active");
  });
});

// Youtube video loader on custom video page

document.addEventListener("DOMContentLoaded", function () {
  if (!document.body.classList.contains("post-template")) return;
  const playBtn = document.getElementById("playBtn");
  if (!playBtn) return;

  function getYouTubeID() {
    let videoId = window.postVideoId;

    if (!videoId) {
      const contentLink = document.querySelector(
        '.post-content a[href*="youtube.com"], .post-content a[href*="youtu.be"]'
      );
      if (contentLink) {
        const linkMatch = contentLink.href.match(
          /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/
        );
        if (linkMatch) videoId = linkMatch[1];
      }
    }

    const DEFAULT_VIDEO_ID = "Ohm1JZv_dbM"; // Default Youtube video ID

    return videoId || DEFAULT_VIDEO_ID;
  }

  playBtn.addEventListener(
    "click",
    () => {
      const embed = document.getElementById("youtubeEmbed");
      const wrapper = document.getElementById("videoWrapper");
      const id = getYouTubeID();

      embed.innerHTML = `<iframe
      src="https://www.youtube.com/embed/${id}?autoplay=1&rel=0"
      frameborder="0"
      allow="autoplay; encrypted-media"
      allowfullscreen
      style="width:100%;aspect-ratio:16/9;display:block;"
      ></iframe>`;

      wrapper.style.display = "none";
      embed.style.display = "block";
    },
    { once: true }
  );
});
